var _a;
import { __decorate, __metadata, __param } from "tslib";
import { LocalStorageService } from '@/domains/local-storage/types/local-storage-service.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FOLDER_STATUS_LOCAL_PREFIX_KEY } from '../constants';
import { treeForEach } from '@/infrastructure/utils/array';
let FolderListStatusServiceImpl = class FolderListStatusServiceImpl {
    constructor(_localStorageService) {
        this._localStorageService = _localStorageService;
    }
    getCollapsedFolders(spaceId) {
        return this._localStorageService.getItem(`${FOLDER_STATUS_LOCAL_PREFIX_KEY}${spaceId}`) || [];
    }
    setCollapsedFolders(spaceId, collapsedFolders) {
        this._localStorageService.setItem(`${FOLDER_STATUS_LOCAL_PREFIX_KEY}${spaceId}`, collapsedFolders);
    }
    getParentFolderIds(folderList) {
        const parentFolderIds = [];
        for (const folder of folderList) {
            if (folder.children) {
                parentFolderIds.push(...this.getParentFolderIds(folder.children));
            }
            parentFolderIds.push(folder.folder_id);
        }
        return parentFolderIds;
    }
    getParentFolders(folderList, folderId) {
        let parentFolders = [];
        treeForEach(folderList, 'children', (folder, level, parentPath) => {
            if (folder.folder_id === folderId) {
                parentFolders = parentPath;
                return false;
            }
        });
        return parentFolders.map(folder => folder.folder_id);
    }
};
FolderListStatusServiceImpl = __decorate([
    injectable(),
    __param(0, inject(LocalStorageService)),
    __metadata("design:paramtypes", [typeof (_a = typeof LocalStorageService !== "undefined" && LocalStorageService) === "function" ? _a : Object])
], FolderListStatusServiceImpl);
export { FolderListStatusServiceImpl };
